import { render, staticRenderFns } from "./parkingSpaceTree.vue?vue&type=template&id=1c9971ef&scoped=true"
import script from "./parkingSpaceTree.vue?vue&type=script&lang=js"
export * from "./parkingSpaceTree.vue?vue&type=script&lang=js"
import style0 from "./parkingSpaceTree.vue?vue&type=style&index=0&id=1c9971ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9971ef",
  null
  
)

export default component.exports